// extracted by mini-css-extract-plugin
export var footerSocialItem = "social-medias-module--footer-social-item--46cfa";
export var footerSocialLinks = "social-medias-module--footer-social-links--c809e";